.banner {
  margin: 8px 12px 0;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: var(--marine);
  background: var(--ice-blue-dark);
  border: solid 1px var(--tealish);
  border-radius: 4px;
}

.bannerLink {
  margin-left: 12px;
  font-weight: bold;
  color: var(--tealish);
  text-decoration: none;
  cursor: pointer;
}

.bannerLink:hover {
  text-decoration: underline;
}

.flowHeader {
  margin: 8px 12px 0;
  background: var(--light-grey);
}

.legendRow {
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 14px;
  color: var(--black);
}

.flowTitle {
  font-weight: bold;
  color: var(--marine);
}

.legend {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  border-radius: 10px;
  cursor: pointer;
}

.legend:hover {
  background: var(--very-light-pink);
}

.legend.selected {
  background: var(--fully-white);
  box-shadow: 0 0 0 1px var(--pinkish-grey);
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  background: var(--lane);
}

.rootDot {
  background: var(--bb-grey);
}
